export default __webpack_public_path__ + "static/media/coinzoom.ef4d4297.svg";